import {
  DELETE_CREDENTIALS_REQUEST_ASYNC,
  DISABLE_INTEGRATION_REQUEST_ASYNC,
  ENABLE_INTEGRATION_REQUEST_ASYNC,
  SET_LOADER,
  STATUS_REQUEST_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    data: {},
    loader: false,
    error: null,
  }
  return (state = initialState, action) => {
    switch (action.type) {
      case STATUS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case STATUS_REQUEST_ASYNC.SUCCESS:
        return { ...state, loader: false, data: action.payload.data }
      case STATUS_REQUEST_ASYNC.ERROR:
        return { ...state, loader: false, error: action.error }
      case SET_LOADER: {
        return {
          ...state,
          loader: action.payload,
        }
      }
      case ENABLE_INTEGRATION_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case ENABLE_INTEGRATION_REQUEST_ASYNC.SUCCESS:
        return { ...state, loader: false, data: action.payload.data }
      case ENABLE_INTEGRATION_REQUEST_ASYNC.ERROR:
        return { ...state, loader: false }
      case DISABLE_INTEGRATION_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case DISABLE_INTEGRATION_REQUEST_ASYNC.SUCCESS:
        return { ...state, loader: false, data: action.payload.data }
      case DISABLE_INTEGRATION_REQUEST_ASYNC.ERROR:
        return { ...state, loader: false }
      case DELETE_CREDENTIALS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case DELETE_CREDENTIALS_REQUEST_ASYNC.SUCCESS:
        return { ...state, loader: false, data: action.payload.data }
      case DELETE_CREDENTIALS_REQUEST_ASYNC.ERROR:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
